import { Controller } from "@hotwired/stimulus"

// Old pasted snippets still listen for this message. Give them the fixed
// contract once; host replies never change the card's layout (#2413).
export default class extends Controller {
  static values = { height: Number }

  declare heightValue: number

  connect() {
    if (window.parent === window) return

    window.parent.postMessage(
      { type: "indee:resize", height: this.heightValue },
      "*",
    )
  }
}
